/*
 * (c) copyright 2021 International Road Dynamics Inc. and related companies.
 * All rights reserved.
 * Copyright as an unpublished work.
 *
 * This file contains confidential information of International
 * Road Dynamics Inc. and related companies, and should be treated as proprietary
 * and confidential.
 *
 * The use, copying, disclosure or modification of the
 * programs and/or source code is prohibited unless
 * otherwise provided for in the license or confidentiality
 * agreements.
 *
 * Any copy must contain this copyright notice.
 */

import React from 'react'

import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import {
  SiteStatuses,
  SiteTypes
} from '../../constants'
import {
  getIconUrlBySiteType,
  getIconUrlByStatus
} from '../../util/Helpers'

import './MapLegend.css'

function MapLegend (props) {
  const legendItems = []

  Object.keys(SiteStatuses).forEach((status) => {
    legendItems.push(
      <div key={status}>
        <img className="pin" src={getIconUrlByStatus(status)} />
        {SiteStatuses[status]}
      </div>
    )
  })

  Object.keys(SiteTypes).forEach((type) => {
    legendItems.push(
      <div key={type}>
        <img className="icon" src={getIconUrlBySiteType(type)} />
        {SiteTypes[type]}
      </div>
    )
  })

  return (
    <Accordion id="mapLegend" defaultExpanded={true}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
      >
        <Typography>Map Legend</Typography>
      </AccordionSummary>
      <AccordionDetails className="MapLegendDetails">
        {legendItems}
      </AccordionDetails>
    </Accordion>
  )
}

export default MapLegend
